/** @module SiteAdmin/CentricDrive/CentricDriveNewFromCloudDocument **/
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/comm/PostRequest",
	"csi/sessionConstants",
	"csi/table/New",
	"csi/xml",
], function (declare, lang, PostRequest, sessionConstants, New) {

	return declare(New, {
		saveResourceId: "BUTTON_UPLOAD",

		/**
		 * @override
		 * Disables Save and New Button
		 */
		_canRepeat: function () {
			return false;
		},

		/**
		 * @override
		 * Disables Save and go button
		 */
		_canNavigate: function () {
			return false;
		},

		/**
		 * @override
		 * Allow only selecting one theme
		 */
		onFormData: function (fd) {
			fd.m_bSelectOne = true;
			fd.m_bRequireOne = true;
			fd.m_fAggregateTest = (ctx, fd) => ctx.getNode().Type === "file";
		},

		/**
		 * @override
		 * Publish request to create new document
		 */
		process: function () {
			const selectedNode = this.getFormData().getSelectedNode();

			const req = new PostRequest("SiteAdmin", "CreateDocumentFromCentricDrive");
			req.addParameter("Name", selectedNode.DisplayName);
			req.addParameter("OriginalFilePath", selectedNode.RelativePath);
			req.addParameter("ContentType", selectedNode.ContentType);
			req.addParameter("FileId", selectedNode.FileId);
			req.addParameter("Size", selectedNode.Size);
			req.addParameter("ParentURL", this.m_urlParent);
			req.addParameter("SessionURL", sessionConstants.sessionUrl);
			this.waitForPublish(req.post(), true);
		},
		/**
		 * @override
		 * Track URL of new document
		 */
		onPublishResponse: function (response) {
			this.m_urlNode = response.getResultNode().$URL;
		},
	});
});
